import { useState } from 'react'
import OurStoryTab from './OurStoryTab'
import PhotosTab   from './PhotosTab'
import VowWriterPage from '../VowWriterPage'
import { useSwipeTabs } from '../../../lib/swipe'

const TABS = [
  { id:'photos', label:'Photos' },
  { id:'story', label:'Our Story' },
  { id:'vows', label:'Vow & Speech Writer' },
]

export default function ProfilePage() {
  const [tab, setTab] = useState('photos')
  const swipe = useSwipeTabs(TABS.map(t => t.id), tab, setTab)

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:0 }}>
      {/* Tab bar */}
      <div style={{ display:'flex', borderBottom:'1px solid #E5E0D8', marginBottom:'1.75rem', overflowX:'auto', scrollbarWidth:'none' }} className="tab-row">
        {TABS.map(t=>(
          <button key={t.id} onClick={()=>setTab(t.id)} style={{
            padding:'0.75rem 1.125rem', background:'none', border:'none', cursor:'pointer',
            fontFamily:'Nunito Sans, sans-serif', fontSize:'0.85rem',
            fontWeight:tab===t.id?700:500,
            color:tab===t.id?'#C4826A':'#6B6B6B',
            borderBottom:tab===t.id?'2px solid #C4826A':'2px solid transparent',
            transition:'all 0.15s', whiteSpace:'nowrap', flexShrink:0
          }}>{t.label}</button>
        ))}
      </div>

      <div {...swipe}>
        {tab==='story'  && <OurStoryTab/>}
        {tab==='photos' && <PhotosTab/>}
        {tab==='vows'   && <VowWriterPage/>}
      </div>
    </div>
  )
}
